<template>
    <label :for="labelFor" :title="title" :class="classes">
        <slot></slot>
        <sup class="text-danger" :dusk="`${labelFor}-asterisk`" v-if="required">*</sup>
    </label>
</template>

<script>
export default {
    name: "VLabel",
    props: {
        labelFor: {
            type: [Number, String]
        },
        title: {
            type: String,
            default: ""
        },
        classes: {
            type: String,
            default: "form__label"
        },
        required: {
            type: Boolean,
            default: false
        }
    }
};
</script>
